const getters = {
  zchjform: state => state.common.zchjform,
  zcjdform: state => state.common.zcjdform,
  xmsbform: state => state.common.xmsbform,
  zhaobiaoform: state => state.common.zhaobiaoform,
  caigouform: state => state.common.caigouform,
  xiaoshouform: state => state.common.xiaoshouform,
}
export default getters
